import { useEffect } from 'react';
import { useScroll } from 'motion/react';
import { useToggleBoolean } from '@spellix/hooks';
import { HEADER_HEIGHT } from '../constants';

const SCROLL_THRESHOLD = HEADER_HEIGHT;

export const useHeaderScrolled = () => {
  const { scrollY } = useScroll();
  const [hasScrolled, { on: setScrolled, off: unsetScrolled }] = useToggleBoolean(false);

  useEffect(() => {
    return scrollY.on('change', (latest) => {
      if (latest > SCROLL_THRESHOLD) {
        setScrolled();
      } else {
        unsetScrolled();
      }
    });
  }, [scrollY]);

  return { hasScrolled };
};
